import { View } from "react-native";
import useStyle from "src/hooks/useStyle";
import { color } from "src/styles";

const FloatingNotificationDot = ({ size }: { size: number }) => {
	const { theme } = useStyle();

	return (
		<View
			testID="NotificationDot"
			pointerEvents="none"
			style={{
				position: "absolute",
				top: 0,
				right: 0,
				width: size,
				height: size,
				borderRadius: size / 2,
				backgroundColor: color.Alert[theme],
			}}
		/>
	);
};
export default FloatingNotificationDot;
